import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { takeLoginRedirect } from './googleSignIn';

// Before anything renders: see googleSignIn.js
const loginRedirect = takeLoginRedirect();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App loginRedirect={loginRedirect} /></React.StrictMode>);
